const theme = {
    colors: {
        background: {
            primary: '#FFFFFF',
            secondary: '#F5F5F5',
            tertiary: '#EFEFEF',
            elevated: '#FFFFFF'
        },
        text: {
            primary: '#1C1C1C',
            secondary: '#696969',
            tertiary: '#909090',
            accent: '#1DB954'
        },
        border: {
            light: 'rgba(0, 0, 0, 0.1)',
            medium: 'rgba(0, 0, 0, 0.15)',
            accent: '#1DB954'
        },
        player: {
            background: '#E8F5E9',
            accent: '#1DB954',
            hover: '#1ed760'
        },
        toggle: {
            active: '#1DB954',
            inactive: '#E0E0E0',
            thumb: '#FFFFFF'
        }
    },
    typography: {
        fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
        fontSize: {
            small: '0.875rem',
            base: '1rem',
            large: '1.125rem',
            xlarge: '1.25rem'
        },
        fontWeight: {
            normal: 400,
            medium: 500,
            semibold: 600,
            bold: 700
        }
    },
    spacing: {
        small: '0.5rem',
        base: '1rem',
        large: '1.5rem',
        xlarge: '2rem'
    },
    borderRadius: {
        small: '4px',
        base: '8px',
        large: '12px',
        full: '9999px'
    },
    shadows: {
        small: '0 2px 4px rgba(0, 0, 0, 0.05)',
        medium: '0 4px 6px rgba(0, 0, 0, 0.07)',
        large: '0 8px 16px rgba(0, 0, 0, 0.1)'
    }
};

export default theme; 